import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  HeaderComponent,
  FooterComponent
} from './components';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMapboxGLModule } from 'ngx-mapbox-gl';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { LeafletDrawModule } from '@asymmetrik/ngx-leaflet-draw';
import { RouterModule } from '@angular/router';
import { DynamicLoaderComponentService } from '@app/core/services/dynamic-loader-component/dynamic-loader-component.service';
import { CommonErrorComponent } from './components/common-error/common-error.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormatFileSizePipe } from './pipes/format-file-size.pipe';
import { SafeHtmlPipe } from './pipes/SafeHtmlPipe';
import { environment } from '@env/index';
import { CheckoutHeaderComponent } from "../pages/payment/checkout/header/checkout.header.component";
import { VoucherHeaderComponent } from './components/voucher-header/voucher-header.component';
import { VoucherFooterComponent } from './components/voucher-footer/voucher-footer.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { TooltipDirective } from './components/tooltip/tooltip.directive';
import { AddToCartDialogComponent } from './components/add-to-cart/add-to-cart.component';
import { ShoppingCartService } from './services/shopping-cart/shopping-cart.service';
import { ProgressSpinnerComponent } from './components/progress-spinner/progress-spinner.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { BaseComponent } from './components/base/base/base.component';
import { DateLocalePipe } from './pipes/date-locale.pipe';
import { ZuoraPaymentComponent } from './components/zuora-payment/zuora-payment.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NoPurchasesComponent } from '@app/pages/charts-manager/my-charts-list/no-purchases/no-purchases.component';
import { MonikerImageComponent } from './components/moniker-image/moniker-image.component';
import { MaintenancePaymentModeComponent } from './components/maintenance-payment-mode/maintenance-payment-mode.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    CommonErrorComponent,
    FormatFileSizePipe,
    SafeHtmlPipe,
    CheckoutHeaderComponent,
    VoucherHeaderComponent,
    VoucherFooterComponent,
    TooltipComponent,
    TooltipDirective,
    AddToCartDialogComponent,
    ProgressSpinnerComponent,
    BaseComponent,
    DateLocalePipe,
    ZuoraPaymentComponent,
    NoPurchasesComponent,
    MonikerImageComponent,
    MaintenancePaymentModeComponent
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    MatInputModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatDividerModule,
    MatCardModule,
    MatIconModule,
    MatProgressSpinnerModule,
    CommonErrorComponent,
    RouterModule,
    MatSelectModule,
    FormatFileSizePipe,
    TranslateModule,
    NgxMapboxGLModule,
    LeafletModule,
    LeafletDrawModule,
    SafeHtmlPipe,
    MatDialogModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    CheckoutHeaderComponent,
    VoucherHeaderComponent,
    VoucherFooterComponent,
    CarouselModule,
    TooltipComponent,
    TooltipDirective,
    ProgressSpinnerComponent,
    DateLocalePipe,
    MatStepperModule,
    MatRadioModule,
    ZuoraPaymentComponent,
    NoPurchasesComponent,
    MonikerImageComponent,
    MaintenancePaymentModeComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDividerModule,
    MatButtonModule,
    RouterModule,
    NgxMapboxGLModule.withConfig({
      accessToken: environment.mapboxToken
    }),
    LeafletModule,
    LeafletDrawModule,
    MatProgressSpinnerModule,
    TranslateModule,
    MatSelectModule,
    MatDialogModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    OverlayModule,
    MatStepperModule,
    MatRadioModule
  ],
  providers: [
    DynamicLoaderComponentService,
    ShoppingCartService,
    DateLocalePipe
  ],
  entryComponents: [
    TooltipComponent,
    AddToCartDialogComponent,
    ProgressSpinnerComponent
  ]
})
export class SharedModule { }
